'use client';

import { ICardSpotter } from '@/types/spots/cardSpotter';
import Image from 'next/image';
import { capitalizeFirstLetter } from '@/utils/lib/firstLetterCapitalize';
import Link from 'next/link';
import { useModale } from '@/app/hooks/useModale';
import { Modale } from '@/app/components/modale/Modale';

export const CardSpotter: React.FC<ICardSpotter> = ({
  image_url,
  alias,
  gi_count,
  owner_id,
}): React.JSX.Element => {
  const { isModaleVisible, openModale, closeModale } = useModale();

  return (
    <>
      <div className="flex items-center bg-zinc-900 rounded-lg p-4 shadow-lg gap-2">
        <div key={owner_id} className="mr-4 flex-shrink-0">
          <Image
            src={image_url}
            alt={`Avatar of ${alias}`}
            title={`Avatar of ${alias}`}
            width={50}
            height={50}
            sizes="(max-width: 640px) 48px, (max-width: 768px) 56px, (max-width: 1024px) 64px, 64px"
            className="rounded-full object-cover w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-white text-lg font-bold xs:text-md sm:text-base xs:text-base xl:text-lg font-primaryBold truncate">
            {capitalizeFirstLetter(alias)}
          </h3>
          <p className="text-gray-400 xl:text-base lg:text-base sm:text-base font-primary">
            {gi_count} spots
          </p>
        </div>
        <Link
          href="#"
          title="Voir le profil"
          className="text-red-600 hover:text-red-800 lg:text-md md:text-md xl:block hidden whitespace-nowrap"
          onClick={(e) => {
            e.preventDefault();
            openModale();
          }}
        >
          Voir le profil
        </Link>
      </div>

      {isModaleVisible && <Modale closeModale={closeModale}></Modale>}
    </>
  );
};
